import { setLocalStorage, getLocalStorage } from "./GetSetStorage";
import { getTimeOfDay } from "./Time";
import { translateEnRu, langCurrent, setPlaceholderName } from "./Translate";
const name = document.querySelector(".name");
let timeOfDay = getTimeOfDay();
let translatePlaceholder;
window.addEventListener("beforeunload", () => {
  setLocalStorage("name", name.value);
});
function showGreeting() {
  const greeting = document.querySelector(".greeting");
  let greetingText = `Good ${timeOfDay}`;
  greeting.textContent = `${greetingText}`;
  let saveName = getLocalStorage("name");
  if (saveName != undefined) {
    name.value = saveName;
  } else {
    setPlaceholderName();

    name.addEventListener("keydown", (e) => {
      if (e.keyCode === 13) {
        setLocalStorage("name", name.value);
        name.placeholder = name.value;
      }
    });
  }
}

showGreeting();
export { showGreeting };
